import axios from 'axios';
import { apiBaseUrl } from './api';

export const translation = async (text, langCode = 'en') => {
  try {
    const baseUrl = apiBaseUrl();
    const response = await axios.post(`${baseUrl}/api/translate`, { text, langCode });

    if (response.status === 201) {
      return response.data.translatedText;
    } else {
      console.error('Translation failed', response);
      return text;
    }
  } catch (error) {
    console.error('Translation failed:', error?.response?.data || error.message);
    return text;
  }
};
//
